import React from 'react';
import {View, StyleSheet, Text} from 'react-native';
import {useTheme} from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialIcons';
import {ActionButton} from '../../shared/components/ActionButton';
import {MainLayout} from '../layouts/MainLayout';

interface ScanErrorScreenProps {
  navigation: any;
  route: {
    params?: {
      errorMessage?: string;
    };
  };
}

export const ScanErrorScreen: React.FC<ScanErrorScreenProps> = ({
  navigation,
  route,
}) => {
  const theme = useTheme();
  const errorMessage = route.params?.errorMessage || 'Código QR no válido';

  const handleRetry = () => {
    // Go back to scan screen
    navigation.goBack();
  };

  const handleGoToDashboard = () => {
    // Navigate to Dashboard using parent navigator
    const parent = navigation.getParent();
    if (parent?.navigate) {
      parent.navigate('Dashboard');
    } else {
      navigation.navigate('Dashboard');
    }
  };

  return (
    <MainLayout navigation={navigation} title="Error de Escaneo">
      <View style={[styles.container, {backgroundColor: theme.colors.background}]}>
        <View style={styles.content}>
          {/* Error Icon */}
          <View style={[styles.iconContainer, {backgroundColor: '#FFEBEE'}]}>
            <Icon name="qr-code-scanner" size={80} color="#EF5350" />
          </View>

          {/* Error Message */}
          <Text style={[styles.title, {color: theme.colors.onBackground}]}>
            Error al Escanear
          </Text>

          <Text style={[styles.message, {color: theme.colors.onSurfaceVariant}]}>
            {errorMessage}
          </Text>

          <Text style={[styles.hint, {color: theme.colors.onSurfaceVariant}]}>
            Asegúrate de escanear un código QR válido del sistema
          </Text>
        </View>

        {/* Action Buttons */}
        <View style={[styles.actions, {backgroundColor: theme.colors.background}]}>
          <ActionButton
            icon="home"
            label="Ir al Inicio"
            variant="outlined"
            onPress={handleGoToDashboard}
            flex={1}
          />
          <ActionButton
            icon="qr-code-scanner"
            label="Escanear de Nuevo"
            variant="contained"
            onPress={handleRetry}
            flex={1}
          />
        </View>
      </View>
    </MainLayout>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  iconContainer: {
    width: 140,
    height: 140,
    borderRadius: 70,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 32,
  },
  title: {
    fontSize: 34,
    fontWeight: 'bold',
    marginBottom: 12,
    textAlign: 'center',
  },
  message: {
    fontSize: 20,
    textAlign: 'center',
    marginBottom: 16,
    lineHeight: 28,
  },
  hint: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 48,
    lineHeight: 24,
    fontStyle: 'italic',
  },
  actions: {
    flexDirection: 'row',
    gap: 12,
    paddingHorizontal: 16,
    paddingTop: 20,
    paddingBottom: 32,
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: -2},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 5,
  },
});
